import { render, staticRenderFns } from "./PaymentsChartEdit.vue?vue&type=template&id=5acd13e5&"
import script from "./PaymentsChartEdit.vue?vue&type=script&lang=js&"
export * from "./PaymentsChartEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports